function usePrequalCookie() {
    const getCookie = cookieName =>
        document.cookie.split('; ').reduce((accumulator, currentValue) => {
            const [key, value] = currentValue.split('=');
            return cookieName === key ? value : accumulator;
        }, '');

    const setCookie = (cookieName, cookieValue) => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 3);
        const expires = '; expires=' + date.toUTCString();
        document.cookie = cookieName + '=' + (cookieValue || '') + expires + '; domain=.eir.ie; path=/';
    };

    return { getCookie, setCookie };
}
function usePrequalSessionCookie() {
    const getSessionCookie = cookieName =>
        document.cookie.split('; ').reduce((accumulator, currentValue) => {
            const [key, value] = currentValue.split('=');
            return cookieName === key ? value : accumulator;
        }, '');

    const setSessionCookie = (cookieName, cookieValue) => {
        document.cookie = cookieName + '=' + (cookieValue || '');
    };

    return { getSessionCookie, setSessionCookie };
    
}

function isJsonObject(strData) {
    try {
        JSON.parse(strData);
    } catch (e) {
        return false;
    }
    return true;
}

function useLocalStorage() {
    // storing input name
    const getLocalStorage = key => {
        if (key) {
            const keyValue = localStorage.getItem(key);
            if(isJsonObject(keyValue)){
                return JSON.parse(keyValue);
            }
           // const isValue = keyValue !== null ? JSON.parse(keyValue) : '';
            return keyValue;
        }
    };

    const setLocalStorage = (key, keyValue) => {
        if (key && keyValue) {
            if(typeof keyValue=='object'){
                localStorage.setItem(key, JSON.stringify(keyValue));
            }else{
                localStorage.setItem(key,keyValue);
            }         
           
        }
    };
    const clearLocalStorage = key => {
        if (key) {
            localStorage.removeItem(key);
        }
    };

    return { getLocalStorage, setLocalStorage, clearLocalStorage };
}

export { usePrequalCookie, useLocalStorage, usePrequalSessionCookie };
